import React, { useEffect, useState } from "react";
import { X, Zap } from "lucide-react";
import { RechargeBox } from "./RechargeCredits";

/* Myntra-light palette */
const C = {
  pink: "#FF3F6C",
  ink: "#282C3F",
  sub: "#535665",
  line: "#EDEDF1",
  card: "#FFFFFF",
  green: "#03A685",
};

/**
 * Global modal that listens for `brandborn:show-renewal` window events
 * (fired by axios interceptor on 402/403 with show_renewal_qr).
 *
 * Self-serve only (user spec, 2026-08): NO plan cards, NO offline QR, NO
 * admin approval. Just the Razorpay recharge — ₹10 = 1 AI listing, pay any
 * amount (UPI QR / card inside Razorpay checkout) and credits activate
 * instantly.
 */
export default function RenewalModal() {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState({ code: "", message: "", feature: "" });

  useEffect(() => {
    const handler = (e) => {
      const d = e.detail || {};
      setReason({ code: d.code || "", message: d.message || "", feature: d.feature || "" });
      setOpen(true);
    };
    window.addEventListener("brandborn:show-renewal", handler);
    return () => window.removeEventListener("brandborn:show-renewal", handler);
  }, []);

  if (!open) return null;

  const heading =
    reason.code === "trial_exhausted"
      ? "Free trial complete — buy credits to continue"
      : reason.code === "credits_exhausted"
      ? "Listing credits over — buy credits to continue"
      : "Buy credits to continue";

  return (
    <div
      className="fixed inset-0 z-[60] grid place-items-center p-4"
      style={{ background: "rgba(15,23,42,0.55)", backdropFilter: "blur(4px)" }}
      data-testid="renewal-modal"
      onClick={() => setOpen(false)}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-md rounded-2xl overflow-hidden"
        style={{ background: C.card, border: `1px solid ${C.line}`, boxShadow: "0 24px 64px rgba(15,23,42,0.18)" }}
      >
        {/* Header */}
        <div className="flex items-start justify-between gap-3 p-5 border-b" style={{ borderColor: C.line }}>
          <div className="flex items-start gap-3">
            <span className="w-10 h-10 rounded-xl grid place-items-center shrink-0" style={{ background: "#E0F4EE" }}>
              <Zap size={18} style={{ color: C.green }} />
            </span>
            <div>
              <div className="text-[10px] uppercase tracking-[0.3em] font-bold" style={{ color: C.pink }}>
                Buy Credits
              </div>
              <h2 className="text-lg font-extrabold mt-0.5" style={{ color: C.ink }}>{heading}</h2>
              <p className="text-xs mt-1" style={{ color: C.sub }}>
                ₹10 = 1 AI Auto Listing. Pay via UPI QR / card — jitna payment, utne credits.
                Credits activate <b>instantly</b> after payment.
              </p>
            </div>
          </div>
          <button
            onClick={() => setOpen(false)}
            className="p-1.5 rounded-lg border"
            style={{ borderColor: C.line, color: C.sub }}
            data-testid="renewal-close"
          >
            <X size={16} />
          </button>
        </div>

        {/* Body — Razorpay self-serve recharge only */}
        <div className="p-5">
          <RechargeBox
            compact
            onSuccess={() => {
              setOpen(false);
              window.location.reload();
            }}
          />
        </div>
      </div>
    </div>
  );
}
